import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik } from "formik";
import * as yup from "yup";

import MenuItem from "@mui/material/MenuItem";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import moment from "moment";

//Services
import LocationApi from "Services/Location";
import countryCodeData from "./data/index.json";
import MapContainer from "./GoogleMaps";
import { Label } from "@mui/icons-material";
import GoogleMapLoader from "../../../../Googlemaploader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateLocationModal = (props) => {
  const { open, handleClose, locationId } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState(null);

  // Maps states
  const [shapesDeleted, setShapesDeleted] = useState(0);
  const [polygonData, setPolygonData] = useState([]);

  const getLocationDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Location Details Api", err);
    };
    LocationApi.getServiceAreaById(locationId).then(onSuccess, onFailure);
  }, [locationId]);
  useEffect(() => {
    open && getLocationDetails();
  }, [open, getLocationDetails]);

  //Maps

  const handleDeleteShapes = () => {
setShapesDeleted((prevCount) => prevCount + 1);
  };

  const handlePolygonChange = (newPolygonData) => {
    //console.log("polygonData ", newPolygonData);
    setPolygonData(newPolygonData);
  };

  const handleReset = () => {
    getLocationDetails();
  };

  //

  const handleUpdateLocations = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    const data = {
      locationName: formValues?.locationName,
      countryId: formValues?.country,
      polygonData: polygonData,
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Updated successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik?.resetForm();
        setDetails(null);
        getLocationDetails();
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while updating",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    if (polygonData != "") {
      LocationApi.updateServiceArea(locationId, { ...data }).then(
        onSuccess,
        onFailure
      );
    } else {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Location data cannot be empty",
          autoHideDuration: 6000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "warning",
        })
      );
    }
  };

  // Formik

  const formik = useFormik({
    initialValues: {
      locationName: "",
      country: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      locationName: yup
        .string()
        .required("location Name is required")
        .trim()
        .min(3, "Name must be atleast 3 letters")
        .max(50, "Max 50 characters are allowed")
        .nullable(),
    }),
    onSubmit: handleUpdateLocations,
  });

  // Formik - Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(details)) {
      //console.log("details ", details);
      formik.setFieldValue("locationName", details?.locationName);
      formik.setFieldValue("country", details?.countryId);
      setPolygonData(details?.polygonData);
    }
  }, [details]);

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Update Locaiton
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12} md={4} lg={4} xl={4}>
              {/* Location Name */}
              <Grid
                container
                xs={12}
                md={12}
                lg={12}
                xl={12}
                className={classes.fieldContainerWrapper}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.fieldContainer}
                >
                  <TextField
                    name="locationName"
                    id="locationName"
                    label="Location Name"
                    value={formik?.values?.locationName}
                    defaultValue={formik?.values?.locationName}
                    onChange={formik?.handleChange}
                    error={
                      formik?.errors?.locationName &&
                      formik?.touched?.locationName
                    }
                    helperText={
                      formik?.errors?.locationName &&
                      formik?.touched?.locationName &&
                      formik?.errors?.locationName
                    }
                    fullWidth
                    variant="outlined"
                    size="small"
                  ></TextField>
                </Grid>
<Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.fieldContainer}
                >
                  <TextField
                    name="country"
                    id="country"
                    select
                    label="Country"
                    value={formik?.values?.country}
                    defaultValue={formik?.values?.country}
                    onChange={formik?.handleChange}
                    error={formik?.errors?.country && formik?.touched?.country}
                    helperText={
                      formik?.errors?.country &&
                      formik?.touched?.country &&
                      formik?.errors?.country
                    }
                    fullWidth
                    variant="outlined"
                    size="small"
                  >
{countryCodeData.map((country) => (
                                <MenuItem
                                  key={country.code}
                                  value={country.name}
                                >
                                  {`${country.name}`}
                                </MenuItem>
                              ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.updateBtn}
                >
                  <Button variant="contained" onClick={formik?.handleSubmit}>
                    Update Location
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            {/* Google Maps Container */}
            <Grid item xs={12} md={8} lg={8} xl={8} style={{ height: "550px" }}>
              <div className={classes.mapContainerStyles}>
                 <GoogleMapLoader>
                <MapContainer
                  showDeleteButton={true}
                  onDeleteShape={handleDeleteShapes}
                  onPolygonChange={handlePolygonChange}
                  initialPolygonData={polygonData}
                 shapesDeleted={shapesDeleted} 
                />
                </GoogleMapLoader>
              </div>

              <Button
                size="large"
                variant="contained"
                style={{ padding: "8px", fontSize: "12px" }}
                onClick={handleDeleteShapes}
              >
                Delete Shapes
              </Button>

              <Button
                size="large"
                variant="contained"
                style={{ padding: "8px", fontSize: "12px", marginLeft: "20px" }}
                onClick={handleReset}
              >
                Reset Location
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateLocationModal;
